"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _RenderApplication = require("../RenderApplication");

var _RenderApplication2 = _interopRequireDefault(_RenderApplication);

require("./Apply.css");

var _VacatureDetails = require("./VacatureDetails");

var _VacatureDetails2 = _interopRequireDefault(_VacatureDetails);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Apply = function Apply(props) {
  var _useState = (0, _react.useState)({
    team_picture: [],
    vacatures: props.vacature,
    color: props.color
  }),
      _useState2 = _slicedToArray(_useState, 2),
      jobsLoaded = _useState2[0],
      setJobsLoaded = _useState2[1];

  var closeModal = function closeModal() {
    props.closeThisModal();
  };

  var Backdrop = function Backdrop() {
    return _react2.default.createElement("div", { className: "backdrop", onClick: closeModal });
  };

  var postApply = function postApply() {
    closeModal();
  };

  var ModalOverlay = function ModalOverlay(props) {
    return _react2.default.createElement(
      "div",
      { className: "modal" },
      _react2.default.createElement(
        "div",
        { className: "content" },
        props.children
      )
    );
  };

  return _react2.default.createElement(
    _react.Fragment,
    null,
    _react2.default.createElement(Backdrop, null),
    _react2.default.createElement(
      ModalOverlay,
      null,
      _react2.default.createElement(_VacatureDetails2.default, { vacature: jobsLoaded.vacatures }),
      _react2.default.createElement(_RenderApplication2.default, {
        sendApplication: postApply,
        jobfunctions: props.vacature.AllVacatures,
        vacature: jobsLoaded.vacatures,
        name: true,
        address: true,
        education: true,
        jobfunction: true,
        message: true,
        resume: true,
        template: jobsLoaded.template
      })
    )
  );
};

exports.default = Apply;